var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckboxCheckBlue = function SvgCheckboxCheckBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 7
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#668FB6",
    strokeWidth: 1.5,
    d: "m.48 3.32 2.56 2.56L7.52.76"
  })));
};
export { SvgCheckboxCheckBlue as ReactComponent };
export default __webpack_public_path__ + "15a56dd5fb6767890450d2cf6f12ac71.svg";